export const CACHE_TIMES_MAP = {
  // 1 minute
  ONE_MINUTE: 1 * 60 * 1000,
  // 5 minutes
  FIVE_MINUTES: 5 * 60 * 1000,
  // 10 minutes
  TEN_MINUTES: 10 * 60 * 1000,
  // 15 minutes
  FIFTEEN_MINUTES: 15 * 60 * 1000,
  // 30 minutes
  THIRTY_MINUTES: 30 * 60 * 1000,
};

export const ACTION_CACHE_TIMES_MAP = {
  GET_SILAL_IMAGES: CACHE_TIMES_MAP.TEN_MINUTES,
  GET_STORE_IMAGES: CACHE_TIMES_MAP.TEN_MINUTES,
  GET_CATEGORIES_MINIMALIST: CACHE_TIMES_MAP.THIRTY_MINUTES,
};

export function shouldRefreshCache(action: any, lastFetch: number): boolean {
  if (lastFetch === undefined || lastFetch === 0) return true;
  const cacheTime =
    ACTION_CACHE_TIMES_MAP[action as keyof typeof ACTION_CACHE_TIMES_MAP];
  const currentTime = new Date().getTime();
  return currentTime - lastFetch > cacheTime;
}
